/** Only an explicit `false` is off, since off restores the panel that shows every layer as allowed when limits fail. */
import { useFeatureFlagEnabled } from '@posthog/react';

export const EXPORT_ENABLE_ASYNC_LIMITS = 'export-enable-async-limits';

export function useExportEnableAsyncLimits(): boolean {
  return useFeatureFlagEnabled(EXPORT_ENABLE_ASYNC_LIMITS) !== false;
}
